export default "__VITE_ASSET__BHOR6hlS__"